import { Future, race } from 'fluture';
import { err } from './error';
export var timeout = function (ms) { return function (fl) {
    return race(Future(function (rej) {
        var timeout = setTimeout(function () {
            return rej(err("Timed out waiting for promise (" + ms + "ms)"));
        }, ms);
        return function () { return clearTimeout(timeout); };
    }))(fl);
}; };
